export default __webpack_public_path__ + "qbo-icon.png";